import React, { useMemo } from 'react';
import ThumbOverlayBackgroundDS from '@wix/da-ds/pkg/thumbs/legos/ThumbOverlayBackground';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
const ThumbOverlayBackground = ({ deviation, className, showDefaultHover })=>{
    const blockType = useDeviationBlockType(deviation);
    const backgroundType = useMemo(()=>{
        // mature and such gets solid
        if (blockType === 'matureFilter') {
            return 'solid';
        }
        // stuff that gets blurred images gets a gradient
        if (blockType) {
            return 'gradient';
        }
    }, [
        blockType
    ]);
    if (backgroundType) {
        return /*#__PURE__*/ React.createElement(ThumbOverlayBackgroundDS, {
            type: backgroundType,
            className: className
        });
    }
    if (showDefaultHover) {
        return /*#__PURE__*/ React.createElement(HoverOnly, null, /*#__PURE__*/ React.createElement(ThumbOverlayBackgroundDS, {
            type: "gradient",
            className: className
        }));
    }
    return null;
};
ThumbOverlayBackground.displayName = 'ThumbOverlayBackground';
export default ThumbOverlayBackground;

//# sourceMappingURL=ThumbOverlayBackground.js.map